<template>
  <!-- 機種管理 -->
  <div id="DeviceKindManagement">
    <div id="container">
      <deviceNavi v-bind:pageid='"DeviceKindManagement"'></deviceNavi>
      <div class="labelTitle lable">種別編集</div>
      <div class="kindEditTable-area clearfix">
        <b-table
            id="kindEditTable"
            :data="kindData"
            aria-next-label="Next page"
            aria-previous-label="Previous page"
            aria-page-label="Page"
            aria-current-label="Current page">
            <template slot-scope="props">
              <b-table-column field="kind" label="種別" centered>
                <input type="text" class="kind-validate" v-model="props.row.kind" validate="required" maxlength="200"/>
              </b-table-column>
              <b-table-column field="value" label="value" width="100" centered>
                <input type="number" class="kind-validate" v-model="props.row.value" validate="required"/>
              </b-table-column>
              <b-table-column field="abbreviation" label="略称" width="100" centered>
                <input type="text" class="kind-validate" v-model="props.row.abbreviation" validate="required" maxlength="50"/>
              </b-table-column>
              <b-table-column field="deleteFlag" label="削除フラグ" width="80" centered>
                <input type="checkbox" v-model="props.row.deleteFlag"/>
              </b-table-column>
              <b-table-column field="delete" label="一行削除" width="80" centered >
                <b-button v-if="props.row.delete" class="clearButton" @click="clearKind(props.index)" icon-left="eraser"></b-button>
              </b-table-column>
            </template>
        </b-table>
      </div>
      <div class="button-area">
        <b-button class="is-primary" style="float:left;" @click="addKind">一行追加</b-button>
        <b-button class="is-primary" style="float:left;margin-left:10px;" @click="kindRegist">登録</b-button>
      </div>
      <div class="button-area"></div>
      <div class="labelTitle lable">機種品目編集</div>
      <div class="result-area">
        <b-table
            id="ItemTable"
            :data="itemData"
            aria-next-label="Next page"
            aria-previous-label="Previous page"
            aria-page-label="Page"
            aria-current-label="Current page">
            <template slot-scope="props">
              <b-table-column field="itemCode" label="品目コード" width="100" centered >
                <template v-if="props.row.delete">
                  <input type="text" class="item-validate" v-model="props.row.itemCode" validate="required" @input="getItemName(props.row)"/>
                </template>
                <template v-else>
                  {{props.row.itemCode}}
                </template>
              </b-table-column>
              <b-table-column field="itemName" label="品目名称" width="300">
                {{props.row.itemName}}
              </b-table-column>
              <b-table-column field="kind" label="種別" width="140" centered>
                <select id="kind" class="item-validate" v-model="props.row.kind" validate="required">
                  <option v-for="kind of kindDataOrg" :value="kind.value" :key="'s' + kind.value">
                    {{kind.kind}}
                  </option>
                </select>
              </b-table-column>
              <b-table-column field="deleteFlag" label="削除フラグ" width="50" centered>
                <input type="checkbox" v-model="props.row.deleteFlag"/>
              </b-table-column>
              <b-table-column field="delete" label="一行削除" width="50" centered >
                <b-button v-if="props.row.delete" class="clearButton" @click="clearItem(props.index)" icon-left="eraser"></b-button>
              </b-table-column>
            </template>
        </b-table>
      </div>
      <div class="button-area">
        <b-button class="is-primary" style="float:left;" @click="addItem">一行追加</b-button>
        <b-button class="is-primary" style="float:left;margin-left:10px;" @click="itemRegist">機種登録</b-button>
      </div>
    </div>
  </div>
</template>

<script>
import naviBar from "@/components/mock/philips/device/DeviceNaviBar";

export default {
  name: "DeviceKindManagement",
  methods: {
    kindRegist: function() {
      var elements = document.getElementsByClassName("kind-validate")
      var result = this.selfMadeValidation(elements)
      var errMsg = result.msg
      if(result.isError){
        this.showErrorMessage('未入力の項目があります。')
      }else if (errMsg != ""){
        this.showErrorMessage('未入力の項目があります。')
      }else {
        if (this.kindInputCheck()) {
          // Web Api Call
          var _this = this;
          this.apiCall(
            function(client){
              return client.apis.internalDeviceManagement.setDeviceKindsPOST({
                body:_this.kindData
              });
            },
            function(result){
              _this.showSuccess(result, function() {
                _this.getDeviceKinds();
              });
            },
            function(result){
              _this.showErrorMessage(result);
            }
          );
        }
      }
    },
    itemRegist: function(){
      var elements = document.getElementsByClassName("item-validate")
      var result = this.selfMadeValidation(elements)
      var errMsg = result.msg
      if(result.isError){
        this.showErrorMessage('未入力の項目があります。')
      }else if (errMsg != ""){
        this.showErrorMessage('未入力の項目があります。')
      }else {
        if (this.itemInputCheck()) {
          var _this = this;
          var _body = this.createDeviceRegistBody();
          this.apiCall(
            function(client){
              return client.apis.internalDeviceManagement.setDeviceModelsPOST({
                body:_body
              });
            },
            function(result){
              _this.showSuccess(result, function() {
                _this.getDeviceModels();
              });
            },
            function(result){
              _this.showErrorMessage(result);
            }
          );
        }
      }
    },
    kindInputCheck: function() {
      if (!this.numberCheck(this.kindData, 'value', 1, 999, 'valueは1以上999以下で入力してください。値=')) {
        return false;
      }

      if (!this.duplicateCheck(this.kindData, 'kind', '種別が重複しています。値=')) {
        return false;
      }

      if (!this.duplicateCheck(this.kindData, 'value', 'valueが重複しています。値=')) {
        return false;
      }

      if (!this.duplicateCheck(this.kindData, 'abbreviation', '略称が重複しています。値=')) {
        return false;
      }

      if (!this.referCheck(this.kindData, this.itemDataOrg)) {
        return false;
      }

      return true
    },
    itemInputCheck: function() {
      if (!this.duplicateCheck(this.itemData, 'itemCode', '品目コードが重複しています。値=')) {
        return false;
      }

      if (!this.deleteCheck(this.kindDataOrg, this.itemData)) {
        return false;
      }

      if (!this.itemCodeCheck(this.itemData)) {
        return false;
      }

      return true
    },
    duplicateCheck: function(datas, name, msgformat) {
      var cnt = {};

      for (var data of datas) {
        if (data.deleteFlag) {
          continue;
        }
        cnt[data[name]] = (cnt[data[name]] || 0) + 1;
      }

      for(var key of Object.keys(cnt)) {
        var num = cnt[key];
        if (num >= 2) {
          this.showErrorMessage(msgformat + key);
          return false;
        }
      }

      return true
    },
    numberCheck: function(datas, name, min, max, msgformat) {
      for (var data of datas) {
        if(parseInt(data[name], 10) < min || parseInt(data[name], 10) > max){
          this.showErrorMessage(msgformat + data[name]);
          return false;
        }
      }

      return true
    },
    referCheck: function(kinds, items) {
      // 種別編集時に、機種品目から参照されているチェック

      var notfoundItem = items.find(item => {
        var res = kinds.find(kind => {
          if (!kind.deleteFlag || (kind.deleteFlag && item.deleteFlag)) {
            return item.kind == kind.value;
          }
        });

        if (!res) {
          return true;
        }
      })

      if (notfoundItem) {
        var beforeKind = this.kindDataOrg.find(kindorg => {
          return notfoundItem.kind == kindorg.value;
        })

        if (beforeKind) {
          this.showErrorMessage('使用中の種別を削除、または、valueを変更することはできません。変更前 種別=' + beforeKind.kind + ' value=' + notfoundItem.kind);
          return false
        }
      }

      return true
    },
    deleteCheck: function(kinds, items) {
      // 機種品目編集時に、種別が削除されているかチェック
      var delkind = null;
      items.find(item => {
        if (item.deleteFlag) {
          return;
        }
        var kind = kinds.find(kind => {
          return item.kind == kind.value;
        });

        if (kind.deleteFlag) {
          return delkind = kind;
        }
      })

      if (delkind) {
        this.showErrorMessage('選択された種別は削除されています。種別=' + delkind.kind);
        return false
      }

      return true
    },
    itemCodeCheck: function(items) {
      var item = items.find(item => {
        if (!item.itemName) {
          return item;
        }
      });

      if (item) {
        this.showErrorMessage("正しい品目コードを指定してください。");
        return false;
      }
      return true
    },
    addKind: function() {
      this.kindData.push(
        {
          abbreviation:null,
          deleteFlag:false,
          kind:null,
          value:null,
          delete:true
        }
      );
    },
    addItem: function(){
      this.itemData.push(
        {
          itemCode:null,
          itemName:null,
          kind:null,
          deleteFlag:false,
          delete:true
        }
      );
    },
    clearKind: function(index){
      this.kindData.splice(index, 1);
    },
    clearItem: function(index){
      this.itemData.splice(index, 1);
    },
    getDeviceKinds: function(){
      // Web Api Call
      var _this = this;
      this.apiCall(
        function(client){
          return client.apis.internalDeviceManagement.getDeviceKindsPOST({
            body:{}
          });
        },
        function(result){
          _this.kindData = result.obj
          _this.kindDataOrg = JSON.parse(JSON.stringify(result.obj))
        },
        function(result){
          _this.showErrorMessage(result);
        }
      );
    },
    getDeviceModels: function() {
      // Web Api Call
      var _this = this;
      this.apiCall(
        function(client){
          return client.apis.internalDeviceManagement.getDeviceModelsPOST({
            body:{}
          });
        },
        function(result){
          _this.itemData = result.obj
          _this.itemDataOrg = JSON.parse(JSON.stringify(result.obj))
        },
        function(result){
          _this.showErrorMessage(result);
        }
      );
    },
    createDeviceRegistBody: function() {
      var result = this.itemData.slice();
      for (var item of result) {
        if (item.kindId) {
          continue;
        }

        for (var kind of this.kindData) {
          if (kind.value == item.kind) {
            item.kindId = kind.value;
            break;
          }
        }
      }

      return result;
    },
    getItemName: function(row){
      // WebAPI Call
      let _this = this;
      this.apiAnsyncCall(
        function(client){
          return client.apis.apiCommon.getItemNamePOST({
            body:{
              itemCode: row.itemCode
            }
          });
        },
        function(result){
          row.itemName = result.obj.itemName;
        },
        function(result){
          row.itemName = result.obj.itemName;
        },
      );
    }
  },
  data() {
    return {
      kindData: [],
      kindDataOrg: [],
      itemData: [],
      itemDataOrg: []
    };
  },
  filters: {},
  components: {
    deviceNavi: naviBar
  },
  mounted: async function() {
   await this.getDeviceKinds();
   await this.getDeviceModels();
  }
};
</script>
<style lang="scss" scoped>
.condition-area {
    display: flex;
}
.clearfix:after {
  content:" ";
  display:block;
  clear:both;
}

</style>


// WEBPACK FOOTER //
// src/components/mock/philips/device/DeviceKindManagement.vue